import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'
import { AddOutline } from 'react-ionicons'

import CategoryGrid from '@components/catalog/category/CategoryGrid'
import CatalogTopMenu from '@components/catalog/CatalogTopMenu'

import {
  ROUTE_CATALOG_CATEGORY_ADD,
} from '@@partner:config/routes'
import CategorySubMenu from '@components/catalog/category/CategorySubMenu'

export default function CatalogCategoriesPage () {
  const { brandSlug } = usePartner()

  return (
    <div className="CatalogCategoriesPage">
      <h1 className="u-heading">Категории</h1>
      <CatalogTopMenu />
      <CategorySubMenu />
      <CategoryGrid brandSlug={brandSlug} />
    </div>
  )
}
